export default "__VITE_ASSET__Das8ky4o__"